"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostOrderChangeProducts = void 0;
const Base_1 = require("./Base");
exports.PostOrderChangeProducts = {
    url: Base_1.URL_BASE + "/OrderChangeProducts",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostOrderChangeProducts.js.map